module.exports = __webpack_public_path__ + "img/electronic_electric_reserved.089e3575.svg";